import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-193">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-yellow-400 shadow-2xl" data-id="element-194">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#EF5B4C] uppercase" data-id="element-195">
          Todo lo que vas a recibir hoy
        </h2>

        <div className="mb-4" data-id="element-196">
          <h3 className="text-2xl font-bold mb-3" data-id="element-197">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-xl pl-4" data-id="element-198">
            <li className="flex items-center font-bold" data-id="element-199">
              <span className="text-yellow-400 mr-3" data-id="element-200">•</span> Megapack ESI
              Primaria – Primer Ciclo completo
            </li>
            <li className="flex items-center font-bold" data-id="element-201">
              <span className="text-yellow-400 mr-3" data-id="element-202">•</span> Megapack ESI
              Primaria – Segundo Ciclo completo
            </li>
            <li className="flex items-center" data-id="element-203">
              <span className="text-yellow-400 mr-3" data-id="element-204">•</span> Más de 250
              actividades listas para imprimir
            </li>
            <li className="flex items-center" data-id="element-205">
              <span className="text-yellow-400 mr-3" data-id="element-206">•</span> BONUS 1:
              Emergentes ESI
            </li>
            <li className="flex items-center" data-id="element-207">
              <span className="text-yellow-400 mr-3" data-id="element-208">•</span> BONUS 2:
              Actividades Express ESI
            </li>
            <li className="flex items-center" data-id="element-209">
              <span className="text-yellow-400 mr-3" data-id="element-210">•</span> BONUS 3: Afiches
              ESI para el Aula
            </li>
            <li className="flex items-center" data-id="element-211">
              <span className="text-yellow-400 mr-3" data-id="element-212">•</span> BONUS 4:
              Ciudadanía Digital para Primaria
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-213">
          <h3 className="text-2xl font-bold mb-3" data-id="element-214">Además vas a tener:</h3>
          <ul className="space-y-2 text-lg" data-id="element-215">
            <li className="flex items-start" data-id="element-216">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-217" />
              <span data-id="element-218">Material listo para imprimir y usar</span>
            </li>
            <li className="flex items-start" data-id="element-219">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-220" />
              <span data-id="element-221">Recursos para todo el año escolar</span>
            </li>
            <li className="flex items-start" data-id="element-222">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-223" />
              <span data-id="element-224">Menos tiempo de planificación</span>
            </li>
            <li className="flex items-start" data-id="element-225">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-226" />
              <span data-id="element-227">Más seguridad para trabajar ESI</span>
            </li>
            <li className="flex items-start" data-id="element-228">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-229" />
              <span data-id="element-230">Actividades organizadas por temas</span>
            </li>
            <li className="flex items-start" data-id="element-231">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-232" />
              <span data-id="element-233">Recursos visuales y claros</span>
            </li>
            <li className="flex items-start" data-id="element-234">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-235" />
              <span data-id="element-236">Herramientas para situaciones reales del aula</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}